import { useEffect } from "react";
import { useGameAuth } from "@/hooks/useGameAuth";
import { GameLayout } from "@/components/game/GameLayout";
import { GameAuthForm } from "@/components/game/GameAuthForm";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { Gamepad2 } from "lucide-react";
import gameBg from "@/assets/game-bg.png";

export const GAME_STARS_CHECKOUT_SESSION_KEY = "flow_game_stars_checkout_session";

export default function GameLanding() {
  const { session, player, loading, signUp, signIn, signOut, resetPassword } = useGameAuth();
  const [searchParams] = useSearchParams();

  // Store referral code from URL
  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) {
      localStorage.setItem("flow_game_referral", ref);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!session?.user || !player) return;
    sessionStorage.setItem(
      GAME_STARS_CHECKOUT_SESSION_KEY,
      JSON.stringify({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
        playerId: player.id,
        timestamp: Date.now(),
      }),
    );
  }, [player, session]);

  if (loading) {
    return (
      <GameLayout player={null} onSignOut={() => {}}>
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-purple-500 border-t-transparent" />
        </div>
      </GameLayout>
    );
  }

  if (session && player) {
    return <Navigate to="/game/marketplace" replace />;
  }

  return (
    <GameLayout player={null} onSignOut={() => {}}>
      <div
        className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 py-8 relative bg-center bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${gameBg})` }}
      >
        <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" aria-hidden="true" />
        <div className="max-w-4xl w-full mx-auto space-y-10 relative z-10">
        {/* Hero */}
        <div className="text-center space-y-5 relative">
          <div className="absolute inset-0 -z-10 flex items-center justify-center">
            <div className="w-72 h-72 bg-purple-500/20 rounded-full blur-[120px] animate-pulse" />
            <div className="w-72 h-72 bg-pink-500/15 rounded-full blur-[100px] animate-pulse absolute" style={{ animationDelay: '1s' }} />
          </div>
          <div className="w-24 h-24 bg-game-neon rounded-3xl flex items-center justify-center mx-auto shadow-game-neon rotate-6 hover:rotate-0 transition-transform duration-500">
            <Gamepad2 className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-5xl md:text-6xl font-extrabold text-game-gradient tracking-tight">
            FLOW Game
          </h1>
          <p className="text-gray-400 text-lg max-w-lg mx-auto leading-relaxed">
            Start with <span className="text-game-pink font-bold">$10</span>, mint, buy & sell.
            Climb the leaderboard and win <span className="text-game-cyan font-bold">real EMON</span> tokens!
          </p>
        </div>

        {/* Auth */}
        <GameAuthForm onSignUp={signUp} onSignIn={signIn} onResetPassword={resetPassword} />
        </div>
      </div>
    </GameLayout>
  );
}
